module.exports = __webpack_public_path__ + "img/qrcode-yx.a5e200b8.jpg";